export const ADD_RECAPZ_STEPS = {
  ADD_BOOKING: 1,
  SELECT_EVENTS_QUANTITY: 2,
  SELECT_RECAP_TYPE: 3,
  RECAP_FORM: 4,
};

export const ALL_EVENT = {
  name: "combined edit",
  id: -1,
};
export const addRecapzInputLimits = {
  MIN: 1,
  MAX: 10,
};

export const RECAP_FORM_FIELDS = {
  REEL_TYPE: "reelType",
  MUSIC: "music",
  ORIENTATION: "orientation",
  DURATION: "duration",
  DESCRIPTION: "description",
  PURPOSE_QUESTION: "purposeQuestion",
};

export const recapOptions = [
  {
    id: 1,
    name: "Highlight",
    title: "highlight recap",
    description:
      "a fast-paced video set to music that shows the best moments. No talking, just a vibe",
  },
  {
    id: 2,
    name: "Storytelling",
    title: "storytelling recap",
    description:
      "a storytelling-style video that uses real voices, like testimonials, speeches, or interviews, with visuals layered in.",
  },
];

export const RECAP_EVENT_TITLE = "Recap";

export const RECAP_FORM = {
  RECAP_TYPE: 0,
  AI_SUMMARY: 1,
};
